import React from "react";
import { object, bool } from "prop-types";
import "./switch.css";
import Switch from "react-switch";

const getValue = (field) => {
  return field.value;
};

const FormikSwitch = ({
  field,
  form: { setFieldValue },
  disabled = false,
  ...props
}) => {
  const value = getValue(field);

  const handleChange = () => {
    if (value === null) {
      return setFieldValue(field.name, true);
    }

    const newValue = !value;

    return setFieldValue(field.name, newValue);
  };

  return (
    <label className="switch-box-label">
      <span>{props.label}</span>
      <Switch
        onColor="#2cba69"
        height={24}
        width={50}
        handleDiameter={22}
        uncheckedIcon={false}
        checkedIcon={false}
        onChange={handleChange}
        checked={!!value}
        disabled={disabled}
      />
    </label>
  );
};

FormikSwitch.propTypes = {
  form: object.isRequired,
  field: object.isRequired,
  disabled: bool,
};

export default FormikSwitch;



// WEBPACK FOOTER //
// ./src/components/formik/Switch.jsx